import { render } from "./ModalFiltroEstudante.vue?vue&type=template&id=e362943c&scoped=true&ts=true"
import script from "./ModalFiltroEstudante.vue?vue&type=script&lang=ts"
export * from "./ModalFiltroEstudante.vue?vue&type=script&lang=ts"

import "./ModalFiltroEstudante.vue?vue&type=style&index=0&id=e362943c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e362943c"]])

export default __exports__